export const REACT_APP_URL = process.env.REACT_APP_URL || 'https://rdvenmairie.fr'
export const API = process.env.REACT_APP_API || 'https://rdvenmairie.fr'
export const BASE_URL = process.env.REACT_APP_BASE_URL || '/'
export const BREAKPOINT_MOBILE = '(max-width: 768px)'
export const BREAKPOINT_TABLETTE = '(max-width: 1024px)'
export const BREAKPOINT_DESKTOP_MD = '(max-width: 1440px)'
export const GMAP_KEY = process.env.REACT_APP_GMAP_KEY || 'AIzaSyBHcLwKiZ0_qXWsIkqMCZI0k-iyXC62A9w'
export const API_ANTS = process.env.API_ANTS ||  'https://api.rendezvouspasseport.ants.gouv.fr/'
export const REACT_APP_TOKEN_COLLECTION = process.env.REACT_APP_TOKEN_COLLECTION || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYzODVmMGEyY2U0OWM2MDA3ZTFhYmFhYyIsImlhdCI6MTY2OTcyMjI3NH0.ebpbJELVmdm6FjEaoBseyfJ0B-Dx8RulM-OmlsCyYT0'
